import { render, staticRenderFns } from "./AddPostura.vue?vue&type=template&id=1723d99f"
import script from "./AddPostura.vue?vue&type=script&lang=js"
export * from "./AddPostura.vue?vue&type=script&lang=js"
import style0 from "./AddPostura.vue?vue&type=style&index=0&id=1723d99f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports